<template>
	<main class="preference-center">
		<form id="preference-center-form" name="preference-center">
			<router-view></router-view>
		</form>
	</main>
</template>

<script>
export default {
	name: 'PreferenceCenterHome',
};
</script>

<style lang="scss">
.preference-center {
	@include rem(padding, 30px 30px);

	@include mobile {
		@include rem(padding, 30px 15px);
	}

	.toggle-switch.on {
		background-color: $brand-blue;
	}

	a {
		@include typo--roboto__medium;
		color: $brand-blue;
		text-decoration: none;

		&:hover {
			text-decoration: underline;
			color: $brand-blue;
		}
	}

	.alert-layout-content {
		@include rem(padding, 20px 0);

		.b360-section-container.b360-grid-row {
			margin-bottom: 0;
		}
	}
}

.preference-center-section {
	@include rem(padding, 10px 0);
	border-bottom: $b360-border-width-thin solid $border-color-light;

	&:last-of-type {
		border: none;
	}
}

.title-description {
	grid-row-start: 1;
	grid-row-end: span 3;

	@include lg {
		@include rem(padding-right, 25px);
	}
}
</style>
